import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "header block" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "search" }
const _hoisted_4 = { class: "container block block-alone" }
const _hoisted_5 = { class: "table" }
const _hoisted_6 = { class: "point" }
const _hoisted_7 = { class: "flex gap-16" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_batchPayroll = _resolveComponent("batchPayroll")!
  const _component_addMaterial = _resolveComponent("addMaterial")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            placeholder: "请输入出险姓名或身份证",
            class: "input search-input",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
            onKeydown: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["enter"]))
          }, null, 544), [
            [_vModelText, _ctx.searchText]
          ]),
          _createElementVNode("button", {
            class: "btn",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)))
          }, "搜索"),
          _createElementVNode("button", {
            class: "btn-white",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onReset && _ctx.onReset(...args)))
          }, "重置")
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            class: "btn",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onAdd && _ctx.onAdd(...args)))
          }, "新增理赔 ")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_tabs, { "model-value": "detail" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_table, {
              data: _ctx.tableData,
              style: {"width":"100%"},
              "header-row-style": { color: '#202536' },
              "row-style": { color: '#5E617D' },
              onSelectionChange: _ctx.handleSelectionChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "outDangerUserName",
                  label: "出险人"
                }),
                _createVNode(_component_el_table_column, {
                  label: "身份证",
                  prop: "outDangerIdCardNo"
                }),
                _createVNode(_component_el_table_column, {
                  label: "保险商品",
                  prop: "companyPlanName"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "outDangerDate",
                  label: "出险时间"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "outDangerPlace",
                  label: "出险地点"
                }),
                _createVNode(_component_el_table_column, { label: "状态" }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("p", _hoisted_6, _toDisplayString(scope.row.reportStatus === 1 || scope.row.reportStatus === 5 ? '处理中' :
                                            scope.row.reportStatus === 2 || scope.row.reportStatus === 6 ? '已结案' :
                                                scope.row.reportStatus === 3 ? '已驳回' : scope.row.reportStatus === 4 ? '已撤销' : '待处理'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, { label: "操作" }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("p", {
                        style: {"color":"#1989FA"},
                        class: "point",
                        onClick: ($event: any) => (
                                        _ctx.$router.push({
                                            path: '/long-insure-report-detail/' + scope.row.reportNo
                                        })
                                        )
                      }, " 查看详情 ", 8, _hoisted_8),
                      (scope.row.reportStatus === 1 && _ctx.canShow(scope.row.insurCompany))
                        ? (_openBlock(), _createElementBlock("p", {
                            key: 0,
                            style: {"color":"#1989FA"},
                            class: "point",
                            onClick: ($event: any) => (_ctx.showAddMaterial(scope.row))
                          }, " 材料 ", 8, _hoisted_9))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data", "onSelectionChange"]),
            _createVNode(_component_el_pagination, {
              class: "pagination",
              currentPage: _ctx.pageNum,
              "onUpdate:currentPage": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.pageNum) = $event)),
              "page-size": _ctx.pageSize,
              "onUpdate:pageSize": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.pageSize) = $event)),
              "page-sizes": [10, 30, 50, 100],
              layout: "total, sizes, prev, pager, next, jumper",
              total: _ctx.total,
              onSizeChange: _ctx.handleSizeChange,
              onCurrentChange: _ctx.getPayrollList
            }, null, 8, ["currentPage", "page-size", "total", "onSizeChange", "onCurrentChange"])
          ])
        ]),
        _: 1
      }),
      (_ctx.isBatchPay)
        ? (_openBlock(), _createBlock(_component_batchPayroll, {
            key: 0,
            onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isBatchPay = false)),
            onComplete: _ctx.getPayrollList,
            isType: "payroll"
          }, null, 8, ["onComplete"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_addMaterial, {
      show: _ctx.showAdd,
      "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showAdd) = $event)),
      insureType: "long",
      "cur-item": _ctx.curItem
    }, null, 8, ["show", "cur-item"])
  ]))
}